import { Body02, Button, Headline06, Notification, NotificationTypeEnum, TextArea } from 'Components/designSystem';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorCode } from 'shared/api';
import { useErrorText } from 'shared/i18n';
import styled from 'styled-components';

import { formValidate } from '../helpers';
import { AskForOpportunitiesFormErrors } from '../types';

interface AskForOpportunitiesFormProps {
    onSubmit: (text: string) => void;
    isLoading: boolean;
    errorCode?: ErrorCode;
}

export default function AskForOpportunitiesForm({ onSubmit, errorCode, isLoading }: AskForOpportunitiesFormProps) {
    const { t } = useTranslation('askForOpportunities');
    const [ text, setText ] = React.useState('');
    const [ errors, setErrors ] = React.useState<AskForOpportunitiesFormErrors | null>(null);
    const errorText = useErrorText();

    const handleChangeText = (value: string) => {
        setText(value);
    };

    const handleSubmit = () => {
        const errors = formValidate({ text });
        setErrors(errors);

        if (!errors) {
            onSubmit(text);
        }
    };

    return (
        <>
            <Title>{ t('title') }</Title>
            <Body02 color="tertiary">{ t('description') }</Body02>
            <TextInputContainer>
                <TextArea value={ text } 
                    onChange={ handleChangeText }
                    placeholder={ t('inputPlaceholder') }
                    required
                    valid={ !errors?.text }
                />
            </TextInputContainer>
            { errorCode && (
                <StyledNotification type={ NotificationTypeEnum.Error }
                    text={ errorText(errorCode) } />
            ) }
            <Button onClick={ handleSubmit }
                width="100%"
                label={ t('send') }
                isLoading={ isLoading } />
        </>
    );
}

const Title = styled(Headline06)`
    margin-bottom: ${ ({ theme }) => theme.size.size_10 };
`;

const TextInputContainer = styled.div`
    padding-top: ${ ({ theme }) => theme.size.size_20 };
    padding-bottom: ${ ({ theme }) => theme.size.size_30 };
`;

const StyledNotification = styled(Notification)`
    border-radius: ${ ({ theme }) => theme.size.size_10 };
    margin-bottom: ${ ({ theme }) => theme.size.size_30 };
`;
